import React, { useEffect } from 'react';
import _ from 'lodash';
import store, { brokerClientActions } from '@apply/adminStore';
import { Accordion, SortableHeader } from '../../common/SharedComponents';
import { formatDate } from '../../common/SharedFunctions';
import { BrokerClientApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { useSelector } from 'react-redux';
import { RefreshEvents } from '../../common/SharedEvents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag, faDownload } from '@fortawesome/free-solid-svg-icons';

const activeColumns = [
    { key: 'Flgd', label: 'Flag', id: 'isFlagged' },
    { key: 'Broker First Name', label: 'Broker First Name', id: 'firstName' },
    { key: 'Last Name', label: 'Last Name', id: 'lastName' },
    {
        key: 'Point of Contact',
        label: 'Point of Contact',
        id: 'pointOfContact',
    },
    { key: 'B-Client Flgd', label: 'Flag', id: 'clientIsFlagged' },
    { key: 'B-Client (Rep.)', label: 'B-Client (Rep.)', id: 'personName' },
    { key: 'Business', label: 'Business', id: 'businessName' },
    { key: 'ICCA Date', label: 'ICCA Date', id: 'iccaDate' },
    { key: 'ICCA Rejected By', label: 'ICCA Rejected By', id: 'rejectedBy' },
    { key: 'Reason', label: 'Reason', id: 'rejectionComment' },
];

const RejectedBrokerClientTable = () => {
    const searchState = useSelector((state) => state.searchState);
    const brokerClientApi = new BrokerClientApi.BrokerClientApi(applicationInsights);
    const { dispatch } = store;

    const refreshEvents = new RefreshEvents();

    const _handleRowClick = (row) => {
        dispatch(brokerClientActions.setBrokerClientId({ brokerClientId: row.id }));
        dispatch(
            brokerClientActions.setBrokerClientOpen({
                openBrokerClientModal: true,
            })
        );
    };

    const _loadBrokerClients = async () => {
        const response = await brokerClientApi.getRejectedBrokerClientGridRows();

        if (response.statusCode !== 200) return;

        set_rows(response.result);
    };

    const [rows, set_rows] = React.useState([]);
    const [sort, set_sort] = React.useState({
        column: 'name',
        direction: 'asc',
    });

    const matchFirstName = (s) =>
        s.firstName && s.firstName.toLowerCase().includes(searchState.searchText.brokerClient.toLowerCase());
    const matchLastName = (s) =>
        s.lastName && s.lastName.toLowerCase().includes(searchState.searchText.brokerClient.toLowerCase());
    const matchPersonName = (s) =>
        s.personName && s.personName.toLowerCase().includes(searchState.searchText.brokerClient.toLowerCase());
    const matchBusinessName = (s) =>
        s.businessName && s.businessName.toLowerCase().includes(searchState.searchText.brokerClient.toLowerCase());

    const sortedRows = _.chain(rows)
        .filter(
            (s) =>
                !searchState.searchText.brokerClient ||
                matchFirstName(s) ||
                matchLastName(s) ||
                matchPersonName(s) ||
                matchBusinessName(s)
        )
        .orderBy(sort.column, sort.direction)
        .value();

    useEffect(() => {
        async function load() {
            await _loadBrokerClients();

            refreshEvents.addRefreshListener(_loadBrokerClients);
        }

        load();
    }, []);

    return (
        <Accordion
            title='Rejected'
            isExpanded={false}
        >
            <div className='card'>
                <div className='card-section'>
                    <table>
                        <thead>
                            <tr>
                                {activeColumns.map((col) => (
                                    <SortableHeader
                                        key={col.key}
                                        column={col}
                                        sort={sort}
                                        onPress={set_sort}
                                    />
                                ))}
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {sortedRows.map((row) => (
                                <tr key={row.id}>
                                    <td
                                        className='isFlagged'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.isFlagged && (
                                            <i
                                                style={{ color: 'darkred' }}
                                                title='Broker is Flagged!'
                                            >
                                                <FontAwesomeIcon icon={faFlag} />
                                            </i>
                                        )}
                                    </td>
                                    <td
                                        className='primary'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.firstName}
                                    </td>
                                    <td
                                        className='primary'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.lastName}
                                    </td>
                                    <td
                                        className='secondary'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.pointOfContact}
                                    </td>
                                    <td
                                        className='secondary'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.clientIsFlagged && (
                                            <i
                                                style={{ color: 'darkred' }}
                                                title='B-Client is Flagged!'
                                            >
                                                <FontAwesomeIcon icon={faFlag} />
                                            </i>
                                        )}
                                    </td>
                                    <td
                                        className='secondary'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.personName}
                                    </td>
                                    <td
                                        className='secondary'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.businessName}
                                    </td>
                                    <td
                                        className='secondary'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {formatDate(new Date(row.iccaDate))}
                                    </td>
                                    <td
                                        className='secondary'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.rejectedBy}
                                    </td>
                                    <td
                                        className='secondary'
                                        onClick={() => _handleRowClick(row)}
                                    >
                                        {row.rejectionComment}
                                    </td>
                                    <td className='secondary actions'>
                                        {row.iccaDownloadUrl && (
                                            <button
                                                className='gridButton'
                                                onClick={() => (window.location.href = row.iccaDownloadUrl)}
                                            >
                                                <FontAwesomeIcon icon={faDownload} /> Download
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Accordion>
    );
};

export default RejectedBrokerClientTable;
